import { render } from "./nav-bar-user.vue?vue&type=template&id=70b63b2d"
import script from "./nav-bar-user.vue?vue&type=script&lang=js"
export * from "./nav-bar-user.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__